<template>
  <div class="page-not-found">
    <h1>404</h1>
  </div>
</template>
